import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_API_URL } from "utils/constants";
import { setLoader } from "./UserDetails";

export const IgniteTalksslice = createSlice({
  name: "IgniteTalks",
  initialState: {
    mostpopularTalksData: [],
    upcomingSessionsData: [],
    dataSentSuccess: null,
    datasentfailure: null,
    isLoaded: false,
    error: false,
  },
  reducers: {
    setMostpopularData: (state, action) => {
      state.mostpopularTalksData = action.payload;
    },
    setUpcomingSessionsData: (state, action) => {
      state.upcomingSessionsData = action.payload;
    },
    setDataSentSuccess: (state, action) => {
      state.dataSentSuccess = action.payload;
    },
    setDataSentFailure: (state, action) => {
      state.datasentfailure = action.payload;
    },
    setError: (state) => {
      state.error = true;
    },
    setIsLoaded: (state, { payload }) => {
      state.isLoaded = payload;
    },
  },
});

export const {
  setMostpopularData,
  setUpcomingSessionsData,
  setDataSentSuccess,
  setDataSentFailure,
  setError,
  setIsLoaded,
} = IgniteTalksslice.actions;

export default IgniteTalksslice.reducer;

/** Most Popular Talks */
export function mostPopularTalks(popularTalksData) {
  return (dispatch) => {
    axios
      .post(
        `${BASE_API_URL}/popularTalks`,
        { popularTalksData },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        dispatch(setMostpopularData(res.data));
        dispatch(getMostPopularData());
        dispatch(setDataSentSuccess());
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(setError(err));
      });
  };
}

export function getMostPopularData() {
  return (dispatch) => {
    dispatch(setLoader(true));
    axios
      .get(`${BASE_API_URL}/popularTalks`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(setMostpopularData(res.data));
        dispatch(setLoader(false));
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(setError(err));
        dispatch(setLoader(false));
      });
  };
}

export function editMostPopularTalks(popularTalksData, id) {
  return (dispatch) => {
    axios
      .put(
        `${BASE_API_URL}/popularTalks/${id}`,
        { popularTalksData },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        dispatch(setMostpopularData(res.data));
        dispatch(getMostPopularData());
        dispatch(setDataSentSuccess());
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(setError(err));
      });
  };
}
export function deleteMostPopularTalks(id) {
  return (dispatch) => {
    axios
      .delete(`${BASE_API_URL}/popularTalks/${id}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(setMostpopularData(res.data));
        dispatch(getMostPopularData());
        dispatch(setDataSentSuccess());
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(setError(err));
      });
  };
}

/** Upcoming Sessions */

export function upcomingSessions(formData) {
  return (dispatch) => {
    axios
      .post(`${BASE_API_URL}/upcomingSessions`, formData, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        dispatch(setUpcomingSessionsData(res.data));
        dispatch(getUpcomingSessions());
        dispatch(setDataSentSuccess());
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(setError(err));
      });
  };
}

export function getUpcomingSessions() {
  return (dispatch) => {
    dispatch(setLoader(true));
    axios
      .get(`${BASE_API_URL}/upcomingSessions`, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        dispatch(setUpcomingSessionsData(res.data));
        dispatch(setLoader(false));
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(setError(err));
        dispatch(setLoader(false));
      });
  };
}

export function editUpcomingSessions(upcomingSessionsData, sessionId) {
  return (dispatch) => {
    axios
      .put(
        `${BASE_API_URL}/upcomingSessions/${sessionId}`,
        upcomingSessionsData,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        dispatch(setUpcomingSessionsData(res.data));
        dispatch(getUpcomingSessions());
        dispatch(setDataSentSuccess());
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(setError(err));
      });
  };
}

export function deleteUpcomingSessionCard(sessionId) {
  return (dispatch) => {
    axios
      .delete(`${BASE_API_URL}/upcomingSessions/${sessionId}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(setUpcomingSessionsData(res.data));
        dispatch(getUpcomingSessions());
        dispatch(setDataSentSuccess());
      })
      .catch((err) => {
        console.log("err", err);
        dispatch(setError(err));
      });
  };
}
